export const ALL_COOK_PLACE_VALUE = -1;
export const ALL_STAFFS_VALUE = -1;
